import { render, staticRenderFns } from "./AgreementPetroleum.vue?vue&type=template&id=5d5eaf4c&"
import script from "./AgreementPetroleum.vue?vue&type=script&lang=js&"
export * from "./AgreementPetroleum.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPetroleum.vue?vue&type=style&index=0&id=5d5eaf4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports